import dashboardClient from '@/axiosClients/dashboardClient'

export const loadActivePatientsCount = async ({state, commit}) => {
    if (state.count !== null) return

    commit('setIsLoadingActivePatientsCount', true)
    try {
        const {data: result} = await dashboardClient.get('/patients/active-count')
        commit('setActivePatientsCount', result.result.data.count)
    } catch (ex) {
        // Silencioso a propósito: si falla (ej. token vencido), el chip
        // simplemente no aparece (count sigue en null) — no debe tumbar la
        // app con una promesa sin manejar, igual que getUnacknowledgedNotifications.
        console.error('Error al cargar el conteo de pacientes activos', ex)
    } finally {
        commit('setIsLoadingActivePatientsCount', false)
    }
}
